import request from '@/utils/request'

// 创建产品
export const addProduct = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/product',
    method: 'post',
    data
  })

// 删除产品
export const delProduct = (params: any) =>
  request({
    url: '/manage/merchant/' + params.merchant_no + '/product/' + params.id,
    method: 'delete'
  })

// 编辑产品
export const setProduct = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/product/' + data.id,
    method: 'patch',
    data
  })

export const setAgentProduct = (data: any) =>
  request({
    url: '/manage/merchant/' + data.merchant_no + '/agent_product/' + data.id,
    method: 'patch',
    data
  })

// 获取产品列表
export const getProductList = (params: any) =>
  request({
    url: '/manage/merchant/' + params + '/product',
    method: 'get'
  })

// 获取产品详情
export const getProductInfo = (params: any) =>
  request({
    url: '/manage/merchant/' + params.merchant_no + '/product/' + params.id,
    method: 'get'
  })

// 收银台配置列表
export const getCheckoutList = (params: any) =>
  request({
    url: `/manage/merchant/${params.merchant_no}/checkout-counter`,
    method: 'get',
    params
  })

//   创建收银台配置
export const setCheckoutConfig = (data: any) =>
  request({
    url: `/manage/merchant/${data.merchant_no}/checkout-counter`,
    method: 'post',
    data
  })

//   编辑收银台配置
export const editCheckoutConfig = (data: any) =>
  request({
    url: `/manage/merchant/${data.merchant_no}/checkout-counter/${data.id}`,
    method: 'patch',
    data
  })

// 删除收银台配置
export const deltConfig = (data: any) =>
  request({
    url: `/manage/merchant/${data.merchant_no}/checkout-counter/${data.id}`,
    method: 'delete',
    data
  })

// 批量修改商户产品
export const batchUpdateProduct = (data: any) =>
  request({
    url: `/manage/product/${data.product_id}/merchant-product`,
    method: 'patch',
    data
  })
